import { FilterOperationType } from 'src/lib/constants'
import {
  FilterValue,
  IEnhancedPlanFilterCriteria,
  IEnhancedUnitFilterCriteria,
} from 'src/types/filterPlans.interfaces'
import { IEnhancedShellFilterCriteria } from 'src/types/filterShells.interfaces'

export const generatePlanFilters = (): IEnhancedPlanFilterCriteria => ({
  additionalBathrooms: { operation: FilterOperationType.EQUALS },
  baseHomePrice: { operation: FilterOperationType.EQUALS },
  baseHousePre: { operation: FilterOperationType.EQUALS },
  basement: { operation: FilterOperationType.EQUALS },
  basePlan: { operation: FilterOperationType.CONTAINS },
  bedrooms: { operation: FilterOperationType.EQUALS },
  bonusRoom: { operation: FilterOperationType.EQUALS },
  changeNumber: { operation: FilterOperationType.CONTAINS },
  communityId: { operation: FilterOperationType.CONTAINS },
  communityName: { operation: FilterOperationType.CONTAINS },
  deck: { operation: FilterOperationType.EQUALS },
  depthOfPlan: { operation: FilterOperationType.WITHIN_RANGE },
  derivedFromCore: { operation: FilterOperationType.EQUALS },
  division: { operation: FilterOperationType.EQUALS },
  effectiveDate: { operation: FilterOperationType.WITHIN_RANGE },
  engineerName: { operation: FilterOperationType.CONTAINS },
  entry: { operation: FilterOperationType.EQUALS },
  entrySqft: { operation: FilterOperationType.WITHIN_RANGE },
  exteriorCladding: { operation: FilterOperationType.CONTAINS },
  exteriorWallConstruction: { operation: FilterOperationType.CONTAINS },
  familyRoom: { operation: FilterOperationType.EQUALS },
  firmName: { operation: FilterOperationType.CONTAINS },
  flex: { operation: FilterOperationType.EQUALS },
  formalDiningRoom: { operation: FilterOperationType.EQUALS },
  formalLivingRoom: { operation: FilterOperationType.EQUALS },
  foundationType: { operation: FilterOperationType.EQUALS },
  fullBathrooms: { operation: FilterOperationType.EQUALS },
  gameRoom: { operation: FilterOperationType.EQUALS },
  garageAlignment: { operation: FilterOperationType.CONTAINS },
  garageLoad: { operation: FilterOperationType.CONTAINS },
  garageSize: { operation: FilterOperationType.WITHIN_RANGE },
  garageSize2: { operation: FilterOperationType.WITHIN_RANGE },
  garageType: { operation: FilterOperationType.CONTAINS },
  golfCartGarage: { operation: FilterOperationType.EQUALS },
  greatRoom: { operation: FilterOperationType.EQUALS },
  halfBathrooms: { operation: FilterOperationType.EQUALS },
  hierarchy: { operation: FilterOperationType.EQUALS },
  homeSqft: { operation: FilterOperationType.WITHIN_RANGE },
  impactWindows: { operation: FilterOperationType.EQUALS },
  indoorFireplace: { operation: FilterOperationType.EQUALS },
  interiorSprinklers: { operation: FilterOperationType.EQUALS },
  interiorWallConstruction: { operation: FilterOperationType.CONTAINS },
  lanaiEnclosures: { operation: FilterOperationType.EQUALS },
  livingAreas: { operation: FilterOperationType.EQUALS },
  loft: { operation: FilterOperationType.EQUALS },
  marketingName: { operation: FilterOperationType.CONTAINS },
  masterBedroomLocation: { operation: FilterOperationType.EQUALS },
  materialRoofType: { operation: FilterOperationType.CONTAINS },
  numberOfCarGarages: { operation: FilterOperationType.EQUALS },
  numberOfCarGarages2: { operation: FilterOperationType.EQUALS },
  numberOfDiningAreas: { operation: FilterOperationType.EQUALS },
  optionalGarage: { operation: FilterOperationType.EQUALS },
  outdoorFireplace: { operation: FilterOperationType.EQUALS },
  outdoorKitchen: { operation: FilterOperationType.EQUALS },
  patio: { operation: FilterOperationType.EQUALS },
  plan: { operation: FilterOperationType.CONTAINS },
  planCategory: { operation: FilterOperationType.EQUALS },
  planCreatedBy: { operation: FilterOperationType.CONTAINS },
  planCreatedDateTime: { operation: FilterOperationType.WITHIN_RANGE },
  planModifiedDateTime: { operation: FilterOperationType.WITHIN_RANGE },
  planName: { operation: FilterOperationType.CONTAINS },
  planOwnedByLennar: { operation: FilterOperationType.EQUALS },
  planStatus: { operation: FilterOperationType.EQUALS },
  planType: { operation: FilterOperationType.EQUALS },
  region: { operation: FilterOperationType.EQUALS },
  roofShape: { operation: FilterOperationType.CONTAINS },
  rvGarage: { operation: FilterOperationType.EQUALS },
  series: { operation: FilterOperationType.CONTAINS },
  sqftOfHomeConditionedSpace: { operation: FilterOperationType.WITHIN_RANGE },
  sqftOfHomeUnderRoof: { operation: FilterOperationType.WITHIN_RANGE },
  stories: { operation: FilterOperationType.EQUALS },
  stormShutters: { operation: FilterOperationType.EQUALS },
  study: { operation: FilterOperationType.EQUALS },
  sunRoom: { operation: FilterOperationType.EQUALS },
  targetProfitPercentage: { operation: FilterOperationType.EQUALS },
  valueEngineered: { operation: FilterOperationType.EQUALS },
  vaultedCeiling: { operation: FilterOperationType.EQUALS },
  widthOfPlan: { operation: FilterOperationType.WITHIN_RANGE },
  yearOfCreation: { operation: FilterOperationType.EQUALS },
})

export const generateUnitFilters = (): IEnhancedUnitFilterCriteria => ({
  basement: { operation: FilterOperationType.EQUALS },
  basePlan: { operation: FilterOperationType.CONTAINS },
  baseUnitPre: { operation: FilterOperationType.EQUALS },
  baseUnitPrice: { operation: FilterOperationType.EQUALS },
  bedrooms: { operation: FilterOperationType.EQUALS },
  bonusRoom: { operation: FilterOperationType.EQUALS },
  changeNumber: { operation: FilterOperationType.CONTAINS },
  communityId: { operation: FilterOperationType.CONTAINS },
  communityName: { operation: FilterOperationType.CONTAINS },
  conditionedSpaceSqFt: { operation: FilterOperationType.WITHIN_RANGE },
  createdBy: { operation: FilterOperationType.CONTAINS },
  createdOn: { operation: FilterOperationType.WITHIN_RANGE },
  deck: { operation: FilterOperationType.EQUALS },
  depthOfUnitInFeet: { operation: FilterOperationType.WITHIN_RANGE },
  depthOfUnitInInches: { operation: FilterOperationType.WITHIN_RANGE },
  derivedFromCore: { operation: FilterOperationType.EQUALS },
  division: { operation: FilterOperationType.CONTAINS },
  effectiveDate: { operation: FilterOperationType.WITHIN_RANGE },
  engineerName: { operation: FilterOperationType.CONTAINS },
  entry: { operation: FilterOperationType.EQUALS },
  entrySqft: { operation: FilterOperationType.WITHIN_RANGE },
  exteriorWallConstruction: { operation: FilterOperationType.CONTAINS },
  familyRoom: { operation: FilterOperationType.EQUALS },
  firmName: { operation: FilterOperationType.CONTAINS },
  flex: { operation: FilterOperationType.EQUALS },
  formalDiningRoom: { operation: FilterOperationType.EQUALS },
  formalLivingRoom: { operation: FilterOperationType.EQUALS },
  foundationType: { operation: FilterOperationType.EQUALS },
  fullBathrooms: { operation: FilterOperationType.EQUALS },
  gameRoom: { operation: FilterOperationType.EQUALS },
  garageSize: { operation: FilterOperationType.WITHIN_RANGE },
  garageSize2: { operation: FilterOperationType.WITHIN_RANGE },
  garageType: { operation: FilterOperationType.CONTAINS },
  greatRoom: { operation: FilterOperationType.EQUALS },
  halfBathrooms: { operation: FilterOperationType.EQUALS },
  hierarchy: { operation: FilterOperationType.CONTAINS },
  impactWindows: { operation: FilterOperationType.EQUALS },
  indoorFireplace: { operation: FilterOperationType.EQUALS },
  interiorSprinklers: { operation: FilterOperationType.EQUALS },
  interiorWallConstruction: { operation: FilterOperationType.CONTAINS },
  lanaiEnclosures: { operation: FilterOperationType.EQUALS },
  livingAreas: { operation: FilterOperationType.EQUALS },
  loft: { operation: FilterOperationType.EQUALS },
  marketingName: { operation: FilterOperationType.CONTAINS },
  masterBedroomLocation: { operation: FilterOperationType.EQUALS },
  modifiedOn: { operation: FilterOperationType.WITHIN_RANGE },
  numberOfCarGarages: { operation: FilterOperationType.EQUALS },
  numberOfCarGarages2: { operation: FilterOperationType.EQUALS },
  numberOfDiningAreas: { operation: FilterOperationType.EQUALS },
  outdoorFireplace: { operation: FilterOperationType.EQUALS },
  outdoorKitchen: { operation: FilterOperationType.EQUALS },
  patio: { operation: FilterOperationType.EQUALS },
  plan: { operation: FilterOperationType.CONTAINS },
  planCategory: { operation: FilterOperationType.CONTAINS },
  planName: { operation: FilterOperationType.CONTAINS },
  region: { operation: FilterOperationType.CONTAINS },
  series: { operation: FilterOperationType.CONTAINS },
  sqftOfUnitUnderRoof: { operation: FilterOperationType.WITHIN_RANGE },
  stories: { operation: FilterOperationType.EQUALS },
  stormShutters: { operation: FilterOperationType.EQUALS },
  study: { operation: FilterOperationType.EQUALS },
  sunRoom: { operation: FilterOperationType.EQUALS },
  totalUnitSqFt: { operation: FilterOperationType.WITHIN_RANGE },
  unitElevation: { operation: FilterOperationType.CONTAINS },
  unitOwnedByLennar: { operation: FilterOperationType.EQUALS },
  unitStatus: { operation: FilterOperationType.EQUALS },
  unitType: { operation: FilterOperationType.EQUALS },
  valueEngineered: { operation: FilterOperationType.EQUALS },
  vaultedCeiling: { operation: FilterOperationType.EQUALS },
  widthOfUnitInFeet: { operation: FilterOperationType.WITHIN_RANGE },
  widthOfUnitInInches: { operation: FilterOperationType.WITHIN_RANGE },
  yearOfCreation: { operation: FilterOperationType.EQUALS },
})

export const generateShellFilters = (): IEnhancedShellFilterCriteria => ({
  architecturalShake: { operation: FilterOperationType.CONTAINS },
  architecturalShingle: { operation: FilterOperationType.CONTAINS },
  basePlan: { operation: FilterOperationType.CONTAINS },
  boardAndBatten: { operation: FilterOperationType.CONTAINS },
  buildingDepthFt: { operation: FilterOperationType.WITHIN_RANGE },
  buildingDepthIn: { operation: FilterOperationType.WITHIN_RANGE },
  buildingSqFt: { operation: FilterOperationType.WITHIN_RANGE },
  buildingWidthFt: { operation: FilterOperationType.WITHIN_RANGE },
  buildingWidthIn: { operation: FilterOperationType.WITHIN_RANGE },
  communityId: { operation: FilterOperationType.CONTAINS },
  communityName: { operation: FilterOperationType.CONTAINS },
  createdBy: { operation: FilterOperationType.CONTAINS },
  createdOn: { operation: FilterOperationType.WITHIN_RANGE },
  derivedFromCore: { operation: FilterOperationType.EQUALS },
  division: { operation: FilterOperationType.CONTAINS },
  exteriorCladding: { operation: FilterOperationType.CONTAINS },
  exteriorWallConstruction: { operation: FilterOperationType.CONTAINS },
  foundationType: { operation: FilterOperationType.EQUALS },
  garageLoad: { operation: FilterOperationType.CONTAINS },
  garageSize: { operation: FilterOperationType.WITHIN_RANGE },
  garageSize2: { operation: FilterOperationType.WITHIN_RANGE },
  garageType: { operation: FilterOperationType.CONTAINS },
  hidden: { operation: FilterOperationType.EQUALS },
  hierarchy: { operation: FilterOperationType.CONTAINS },
  interiorWallConstruction: { operation: FilterOperationType.CONTAINS },
  isParent: { operation: FilterOperationType.EQUALS },
  marketingName: { operation: FilterOperationType.CONTAINS },
  modifiedBy: { operation: FilterOperationType.CONTAINS },
  modifiedOn: { operation: FilterOperationType.WITHIN_RANGE },
  numberOfCarGarages: { operation: FilterOperationType.EQUALS },
  numberOfCarGarages2: { operation: FilterOperationType.EQUALS },
  plan: { operation: FilterOperationType.CONTAINS },
  planCategory: { operation: FilterOperationType.CONTAINS },
  planName: { operation: FilterOperationType.CONTAINS },
  region: { operation: FilterOperationType.CONTAINS },
  shellElevation: { operation: FilterOperationType.CONTAINS },
  shellStatus: { operation: FilterOperationType.CONTAINS },
  shellType: { operation: FilterOperationType.CONTAINS },
  sidingLap: { operation: FilterOperationType.CONTAINS },
  sidingPanel: { operation: FilterOperationType.CONTAINS },
  stories: { operation: FilterOperationType.EQUALS },
  structureType: { operation: FilterOperationType.CONTAINS },
  underRoofSqFt: { operation: FilterOperationType.WITHIN_RANGE },
  units: { operation: FilterOperationType.EQUALS },
  valueEngineered: { operation: FilterOperationType.EQUALS },
  yearOfCreation: { operation: FilterOperationType.EQUALS },
})

export const hasValidFilterValue = (filterValue: FilterValue): boolean => {
  const { secondValue, value, values, valuesToSearch } = filterValue

  // For range filters (both value and secondValue present)
  if (value !== undefined && secondValue !== undefined) {
    // Both values must be valid for range filters
    const isValueValid =
      value !== null &&
      value !== '' &&
      (typeof value !== 'string' || value.trim() !== '') &&
      (typeof value !== 'number' || !isNaN(value))

    const isSecondValueValid =
      secondValue !== null &&
      secondValue !== '' &&
      (typeof secondValue !== 'string' || secondValue.trim() !== '') &&
      (typeof secondValue !== 'number' || !isNaN(secondValue))

    return isValueValid && isSecondValueValid
  }

  // For single value filters
  if (value !== undefined) {
    // For strings, check if not empty
    if (typeof value === 'string' && value.trim() === '') {
      return false
    }
    // For numbers, check if valid number
    if (typeof value === 'number' && isNaN(value)) {
      return false
    }
    // For other types, value exists and is meaningful
    if (value !== null && value !== '') {
      return true
    }
  }

  if (values !== undefined) {
    // Check if array exists and has meaningful values
    return (
      Array.isArray(values) &&
      values.length > 0 &&
      values.some((v) => v !== null && v !== '' && String(v).trim() !== '')
    )
  }

  if (valuesToSearch !== undefined) {
    // Check if array exists and has meaningful values
    return (
      Array.isArray(valuesToSearch) &&
      valuesToSearch.length > 0 &&
      valuesToSearch.some(
        (v) => v !== null && v !== '' && String(v).trim() !== ''
      )
    )
  }

  return false
}
